import { ChangeDetectionStrategy, Component, DestroyRef, inject, input, OnInit, output } from '@angular/core';

/** Presentational bottom-of-screen confirmation banner. Self-dismisses after autoDismissMs. */
@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastComponent implements OnInit {
  readonly message = input.required<string>();
  readonly actionLabel = input<string | null>(null);
  readonly autoDismissMs = input<number>(5000);

  readonly action = output<void>();
  readonly dismissed = output<void>();

  private readonly destroyRef = inject(DestroyRef);
  private dismissedAlready = false;
  private timer: ReturnType<typeof setTimeout> | undefined;

  ngOnInit(): void {
    this.timer = setTimeout(() => this.close(), this.autoDismissMs());
    this.destroyRef.onDestroy(() => clearTimeout(this.timer));
  }

  protected onAction(): void {
    this.action.emit();
    this.close();
  }

  protected close(): void {
    if (this.dismissedAlready) return;
    this.dismissedAlready = true;
    clearTimeout(this.timer);
    this.dismissed.emit();
  }
}
